import React from "react";

import { useLocation, Link } from "react-router-dom";
import { Tab } from "rbx";

const CompanyTabs = () => {
  const location = useLocation();
  return (
    <Tab.Group kind="boxed">
      <Tab
        active={location.pathname.includes("details")}
        as={Link}
        tabIndex="-1"
        to="details"
      >
        <span>Details</span>
      </Tab>
      <Tab
        active={location.pathname.includes("locations")}
        as={Link}
        tabIndex="-1"
        to="locations"
      >
        <span>Locations</span>
      </Tab>
      <Tab
        active={location.pathname.includes("settings")}
        as={Link}
        tabIndex="-1"
        to="settings"
      >
        <span>Settings</span>
      </Tab>
    </Tab.Group>
  );
};

export default CompanyTabs;
